const types = new Map();

function defineType(item) {
    types.set(item.id.toUpperCase(), item)
}

const protocolTypes = {

    StepTest: 'stepTest',
    IntervalTest: 'intervalTest',
    FiveOneFiveTest: 'fiveOneFiveTest',
    RestingTest: 'restingTest',
    Free: 'none',

    find(type) {
        let found = types.get(type.toUpperCase());
        return found ?? {
            id: type,
            label: type
        };
    },

    hasTargetIntensity(type) {
        return (type == this.StepTest || type == this.FiveOneFiveTest  || type == this.IntervalTest );
    }
};


let idx = 0;

defineType({
    id: protocolTypes.StepTest, order: idx++,
    label: 'Graded Exercise Test',
});
defineType({
    id: protocolTypes.IntervalTest, order: idx++,
    label: 'Interval Test',
});
defineType({
    id: protocolTypes.FiveOneFiveTest, order: idx++,
    label: '5-1-5 Test',
});
defineType({
    id: protocolTypes.RestingTest, order: idx++,
    label: 'RMR Resting Test',
});
defineType({
    id: protocolTypes.Free, order: idx++,
    label: 'Free',
});


export default protocolTypes